import React from 'react';
import type { FC } from 'react';

import DiagnosticsPanel from '../components/DiagnosticsPanel';
import type { DiagnosticsPanelProps } from '../components/DiagnosticsPanel';

export const DiagnosticsPanelIntegration: FC<DiagnosticsPanelProps> = (props: DiagnosticsPanelProps) => (
  <DiagnosticsPanel {...props} />
);
